export default {
  GET_CRON_REMINDER_EMAILS_LIST_REQUEST:
    "GET_CRON_REMINDER_EMAILS_LIST_REQUEST",
  GET_CRON_REMINDER_EMAILS_LIST_RESPONSE:
    "GET_CRON_REMINDER_EMAILS_LIST_RESPONSE",
  GET_CRON_SETTINGS_LIST_REQUEST: "GET_CRON_SETTINGS_LIST_REQUEST",
  GET_CRON_SETTINGS_LIST_RESPONSE: "GET_CRON_SETTINGS_LIST_RESPONSE",
  POST_CRON_SETTINGS_REQUEST: "POST_CRON_SETTINGS_REQUEST",
  POST_CRON_SETTINGS_RESPONSE: "POST_CRON_SETTINGS_RESPONSE",
  PUT_CRON_SETTINGS_REQUEST: "PUT_CRON_SETTINGS_REQUEST",
  PUT_CRON_SETTINGS_RESPONSE: "PUT_CRON_SETTINGS_RESPONSE",
  PUT_STATUS_CRON_SETTINGS_REQUEST: "PUT_STATUS_CRON_SETTINGS_REQUEST",
  PUT_STATUS_CRON_SETTINGS_RESPONSE: "PUT_STATUS_CRON_SETTINGS_RESPONSE",
  POST_CRON_SETTINGS_RESPONSE_CLEAR: "POST_CRON_SETTINGS_RESPONSE_CLEAR",
  DELETE_CRON_SETTINGS_REQUEST: "DELETE_CRON_SETTINGS_REQUEST",
  DELETE_CRON_SETTINGS_RESPONSE: "DELETE_CRON_SETTINGS_RESPONSE",
  DELETE_CRON_SETTINGS_RESPONSE_CLEAR: "DELETE_CRON_SETTINGS_RESPONSE_CLEAR",
};
